<template>
  <tbody>
  <tr class="table-row-style">
    <td>{{ contractSummaryDto.id }}</td>

    <template v-if="fromUserDetail()">
      <td>{{ contractSummaryDto.customerId }}</td>
      <td>{{ contractSummaryDto.customerName }}</td>
    </template>

    <template v-if="fromCustomerDetail()">
      <td>{{ contractSummaryDto.userId }}</td>
      <td>{{ contractSummaryDto.username }}</td>
    </template>

    <td v-if="isUpdateMode">
      <DateInputField
          class="w-50 d-inline-block" v-model="updatedDates.startDate"
          labelText="startDatum"
          noLabel/>
      <DateInputField
          class="w-50 d-inline-block" v-model="updatedDates.endDate"
          labelText="einddatum"
          noLabel :sameOrAfter="startDateFormatted()"/>
    </td>
    <td v-else>{{ contractSummaryDto.contractPeriod.startDate }}
      {{
        contractSummaryDto.contractPeriod.endDate ? " tot " + contractSummaryDto.contractPeriod.endDate : "(met onbepaalde duur)"
      }}
    </td>
    <td class="btn-group">
      <button
          v-show="!isUpdateMode"
          class="btn-basic btn-outline-pulse w-auto mr-2" @click="toggleUpdateMode">
        Datums aanpassen
      </button>
      <button
          v-show="!isUpdateMode"
          class="btn-basic btn-outline-pulse" @click="toggleCreateOrder">
        Voeg order toe
      </button>
      <button
          :disabled="isSaving" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse mr-2" @click="save">
        Opslaan
      </button>
      <button
          :disabled="isSaving" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse-dark" @click="toggleUpdateMode">
        Annuleren
      </button>
    </td>
  </tr>
  <tr>
    <td colspan="6" class="p-0">
      <EditContractComponent
          v-if="editorOpen"
          :contractId="contractSummaryDto.id"
          from="this.from"
          :datesFromAllOrders="contractSummaryDto.datesFromAllOrders"
          @hourlyRateAdded="toggleCreateOrder"
          @orderCanceled="toggleCreateOrder"/>
    </td>
  </tr>
  </tbody>
</template>

<script>

import {mapActions} from "vuex";
import {toYearAndMonthAndDay} from "@/util/DateUtil";
import DateInputField from "@/components/inputFields/DateInputField";
import EditContractComponent from "@/components/EditContract/EditContractComponent";

export default {
  name: "ContractTableRowComponent",
  components: {
    DateInputField,
    EditContractComponent
  },
  props: ["contractSummaryDto", "from"],
  data: () => ({
    isUpdateMode: false,
    isSaving: false,
    updatedDates:{
      startDate:undefined,
      endDate:undefined
    },
    editorOpen: false
  }),
  created() {
    this.updatedEndDate = this.contractSummaryDto.contractPeriod.endDate;
  },
  methods: {
    ...mapActions("administrationContract", ["updateContract"]),
    fromUserDetail() {
      return this.from === "userDetail";
    },
    toggleCreateOrder() {
      this.editorOpen = !this.editorOpen;
    },
    fromCustomerDetail() {
      return this.from === "customerDetail";
    },
    toggleUpdateMode() {
      this.isUpdateMode = !this.isUpdateMode;
      this.updatedDates.startDate = this.contractSummaryDto.contractPeriod.startDate;
      this.updatedDates.endDate = this.contractSummaryDto.contractPeriod.endDate;
    },
    save() {
      this.isSaving = true;
      const updateContractDto = this.updatedDates;
      if (confirm("De einddatum van een contract aanpassen kan ertoe leiden dat alle timesheets en orders na de einddatum van dit contract worden weggesmeten. Ben je zeker dat je de einddatum wil aanpassen?")) {
        this.updateContract({
          contractId: this.contractSummaryDto.id,
          updateContractDto,
          from: this.from
        })
            .then(() => {
              this.isSaving = false;
              this.isUpdateMode = false;
            }).catch(() => {
          this.isSaving = false;
          this.isUpdateMode = false;
        });
      } else {
        this.isSaving = false;
        this.isUpdateMode = false;
      }
    },
    startDateFormatted() {
      return toYearAndMonthAndDay(this.contractSummaryDto.contractPeriod.startDate);
    },
  }
};
</script>

<style scoped>
.height {
  height: 65px;
}
</style>